import { useSelector, useDispatch } from "react-redux";

import {
  setShowDeleteConfirmationModal,
  setIsProcessing,
  setSelectedInsurance,
} from "app/store/insurance/slice/insuranceSlice";
import { useDeleteInsuranceMutation } from "app/store/insurance/api/insuranceApi";
import { showSuccessToast, showErrorToast } from "utils/toast";

const useDeleteConfirmationModal = () => {
  const { showDeleteConfirmationModal, selectedInsurance, isProcessing } =
    useSelector((state) => state.insurance);
  const [deleteInsurance] = useDeleteInsuranceMutation();
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(setShowDeleteConfirmationModal(false));
    selectedInsurance && dispatch(setSelectedInsurance(null));
  };

  const handleDeleteInsurance = async () => {
    try {
      dispatch(setIsProcessing(true));
      const { message } = await deleteInsurance(
        selectedInsurance?._id
      ).unwrap();
      showSuccessToast(message);
      handleModalClose();
    } catch (error) {
      showErrorToast(error?.message || "An error occurred.");
    } finally {
      dispatch(setIsProcessing(false));
    }
  };

  return {
    showDeleteConfirmationModal,
    handleModalClose,
    handleDeleteInsurance,
    isProcessing,
  };
};

export default useDeleteConfirmationModal;
